module.exports = __webpack_public_path__ + "static/media/cny-logo-nav.28441705.svg";